import {AbstractRepository} from "../repository";
import {Employee} from "./employees-repository";
import {Client} from "./clients-repository";

type EmployeeProfile = {
  id: number
  identificationNo: string
  firstName: string
  lastName: string
  dateOfBirth: string|null
  emailAddress: string|null
  mobilePhone: string|null
  mobilePhoneNumber: string|null
}

type ClientProfile = {
  id: string
  firstName: string
  lastName: string
  emailAddress: string|null
  mobilePhone: string|null
  gender: string
}

export type Profile = {
  profile_picture: string|null,
} & (EmployeeProfile|ClientProfile)

export default class ProfileRepository extends AbstractRepository {

  /**
   * Fetch profile
   */

  public me(): Promise<Profile> {
    return this.request<{data : Profile}>('GET', 'me')
      .then(data => data.data)
  }
}